import React, { useEffect, useState } from "react";
import "./App.css";
import {
  NavigationLocation,
  NextpageContext,
  NextPageService,
  NpHeader,
  PageLayout,
} from "@cvx/nextpage-react";
import { Breadcrumb } from "antd";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Home from "./pages/home/Home";
import AboutTema from "./pages/aboutTema/AboutTema";
import Refiners from "./pages/refinersByRefiners/RefinersByRefiners";
import BusinessDevelopment from "./pages/newBusinessDevelopment/NewBusinessDevelopment";
import Mercaway from "./pages/newBusinessDevelopment/mercaway/Mercaway";
import FileNotFound from "./pages/fileNotFound/FileNotFound";
import ContactUs from "./pages/contactUs/ContactUs";
import ErrorPage from "./pages/error/Error";
import Sitemap from "./pages/siteMap/SiteMap";
import ErrorBoundary from "./components/page-header/ErrorBoundary";
import { User } from "./core/interfaces/User";
import { TokenContext } from "./context/token-context";
import { UserContext } from "./context/user-context";
import { appInsights } from "./core/services/insight.service";
import CustomFooter from "./components/page-header/Footer";
import Menu from "./components/page-header/Menu";
import TitleSetter from "./components/TitleSetter";
const np = new NextPageService();

np.UI.options.sitename = "technology marketing";
np.UI.layout.setLayout(PageLayout.Layout39);

// ...existing code...
const Breadcrumbs: React.FC = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  // Build items array for Breadcrumb
  const items = [
    {
      title: "Home",
      href: "/",
    },
    ...pathnames.map((value, index) => {
      const to = `/${pathnames.slice(0, index + 1).join("/")}`;
      const isLast = index === pathnames.length - 1;
      return {
        title: value.replace(/([A-Z])/g, " $1").trim(),
        href: isLast ? undefined : to,
      };
    }),
  ];

  return (
    <div className="breadcrumb">
      <Breadcrumb
        separator=">"
        items={items.map(item =>
          item.href
            ? { ...item, onClick: (e: React.MouseEvent) => { e.preventDefault(); window.location.href = item.href!; } }
            : { title: item.title }
        )}
      />
    </div>
  );
};
function App() {
  const UI = np.UI;
  const options = np.options;
  const properties = np.properties;
  const [login, setLogin] = useState(false);
  const [accessToken] = useState<any>();
  const [user] = useState<User>({});
  np.UI.layout.setLayout(PageLayout.Layout12);

  useEffect(() => {
    async function isUserLogin() {
      try {
        if (appInsights) {
          appInsights.trackTrace({
            message: "Checking user login status",
            properties: { component: "App", method: "isUserLogin" }
          });
        }
        setLogin(true);
        if (appInsights) {
          appInsights.trackTrace({
            message: "User login status set to true",
            properties: { component: "App", method: "isUserLogin" }
          });
        }
      } catch (error) {
        if (appInsights) {
          appInsights.trackException({
            exception: error instanceof Error ? error : new Error(String(error)),
            properties: { component: "App", method: "isUserLogin" }
          });
        }
         console.error("Error in isUserLogin:", error);
      }
    }
    isUserLogin();
  }, []);
  try {
    if (appInsights) {
      appInsights.trackTrace({
        message: "Rendering App component",
        properties: { component: "App", method: "render" }
      });
    }
  return login ? (
    <BrowserRouter>
      <TokenContext.Provider value={accessToken}>
        <UserContext.Provider value={user}>
          <NextpageContext.Provider value={{ UI, options, properties }}>
            <ErrorBoundary>
            <header>
              <NpHeader>
                <Menu location={NavigationLocation.Global} nextPage={np} />
              </NpHeader>
            </header>
            <Menu location={NavigationLocation.SiteSpecific} nextPage={np} />
            <main className="container">
              <section id="column1">
                <Routes>
                  <Route path="/aboutTema" element={
                    <TitleSetter title="About TEMA - Technology Marketing">
                      <Breadcrumbs /><AboutTema />
                    </TitleSetter>
                  } />
                  <Route path="/" element={
                    <TitleSetter title="Home - Technology Marketing">
                      <Home />
                    </TitleSetter>
                  } />
                  <Route path="/home" element={
                    <TitleSetter title="Home - Technology Marketing">
                      <Breadcrumbs /><Home />
                    </TitleSetter>
                  } />
                  <Route path="/refinersByRefiners" element={
                    <TitleSetter title="Refiners - Technology Marketing">
                      <Breadcrumbs /><Refiners />
                    </TitleSetter>
                  } />
                  <Route path="/newBusinessDevelopment" element={
                    <TitleSetter title="New Business Development - Technology Marketing">
                      <Breadcrumbs /><BusinessDevelopment />
                    </TitleSetter>
                  } />
                  <Route path="/newBusinessDevelopment/mercaway" element={
                    <TitleSetter title="MERCAWAY℠ - Technology Marketing">
                      <Mercaway />
                    </TitleSetter>
                  } />
                  <Route path="/newBusinessDevelopment/mercaway/:section" element={
                    <TitleSetter title="MERCAWAY℠ - Technology Marketing">
                      <Mercaway />
                    </TitleSetter>
                  } />
                  <Route path="/contactUs" element={
                    <TitleSetter title="Contact Us - Technology Marketing">
                      <Breadcrumbs /><ContactUs />
                    </TitleSetter>
                  } />
                  <Route path="/siteMap" element={
                    <TitleSetter title="Site Map - Technology Marketing">
                      <Breadcrumbs /><Sitemap />
                    </TitleSetter>
                  } />
                  <Route path="/fileNotFound" element={
                    <TitleSetter title="File Not Found - Technology Marketing">
                      <Breadcrumbs /><FileNotFound />
                    </TitleSetter>
                  } />
                  <Route path="/error" element={
                    <TitleSetter title="Error - Technology Marketing">
                      <Breadcrumbs /><ErrorPage />
                    </TitleSetter>
                  } />
                  <Route path="*" element={
                    <TitleSetter title="File Not Found - Technology Marketing">
                      <FileNotFound />
                    </TitleSetter>
                  } />
                </Routes>
              </section>
              <section id="column2"></section>
            </main>
            <CustomFooter />
            </ErrorBoundary>
          </NextpageContext.Provider>
        </UserContext.Provider>
      </TokenContext.Provider>
    </BrowserRouter>
  ) : (
    <p>Loading...</p>
  );
 } catch (error) {
    if (appInsights) {
      appInsights.trackException({
        exception: error instanceof Error ? error : new Error(String(error)),
        properties: { component: "App", method: "render" }
      });
    }
    // Optionally render a fallback UI
    return <ErrorPage />;
  }
}

np.options.navigationRoutes = [
  {
    title: "about TEMA",
    url: "aboutTema",
  },
  {
    title: "new business development",
    url: "newBusinessDevelopment",
    children: [
      {
        title: "MERCAWAY℠",
        url: "mercaway",
      },
    ],
  },
  {
    title: "contact us",
    url: "contactUs",
  },
];

export default App;
